import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import WebhookForm from './WebhookForm';
import { actions as webhookActions } from '../../reducers';
import { actions as errorActions } from '../../../../../../services/errorReporter/reducers';

const mapStateToProps = (state) => {
  return {
    ...state.webhooks,
    webhook: state.webhooks.webhooks[state.webhooks.currentWebhook] || undefined,
    applicationId: state.applications.selectedApplication,
    signals: state.signals.signals,
    errorFetchingSignals: state.signals.errorFetchingSignals,
  };
};

const mapDispatchToProps = (dispatch) => {
  const {
    createWebhookRequest,
    updateWebhookRequest,
    clearFormErrors,
  } = webhookActions;
  const { reportError } = errorActions;

  return {
    actions: bindActionCreators({
      createWebhookRequest,
      updateWebhookRequest,
      clearFormErrors,
      reportError,
    }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookForm);
